<template>
  <!-- 新增物流产品报价 -->
  <div class="page-box" style="padding: 10px 30px;height: 100%;">
    <h4 class="page-box__title" style="margin-bottom: 10px;">产品报价设置</h4>
    <el-form class=""
             id="searchForm"
             :model="searchData"
             ref="searchForm"
             size="mini"
             :inline="true"
             @submit.native.prevent>
      <el-form-item label="运力商产品名称">
<!--        <el-select v-model="searchData.productId"-->
<!--                   filterable-->
<!--                   size="medium"-->
<!--                   class="edit-form__input"-->
<!--                   placeholder="请选择">-->
<!--          <el-option-->
<!--            v-for="(item, index) in productList"-->
<!--            :key="index"-->
<!--            :label="item.label"-->
<!--            :value="item.value"-->
<!--          ></el-option>-->
<!--        </el-select>-->
        <el-input v-model="searchData.productId" clearable class="edit-form__input" placeholder="请输入产品名称" />
      </el-form-item>

      <el-form-item label="状态"
                    style="margin-left: 30px;">
        <el-select v-model="searchData.state"
                   class="edit-form__input"
                   placeholder="请选择">
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否过期"
                    style="margin-left: 30px;">
        <el-select v-model="searchData.isOverdue"
                   class="edit-form__input"
                   placeholder="请选择">
          <el-option
            v-for="(item, index) in styleList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label=""
                    style="margin-left: 30px;">
        <el-button type="primary"
                   icon="el-icon-search"
                   @click="search">查询</el-button>
      </el-form-item>
    </el-form>

    <div class=""
         style="margin: 10px auto 20px;">
      <el-button type="primary"
                 size="small"
                 icon="el-icon-plus"
                 style="width: 120px;"
                 @click="newDetails">新增</el-button>
    </div>

    <el-table :data="tableData"
              :header-cell-style="{ background: '#F3F3F3', color: '#999999' }"
              size="mini"
              v-loading="loading"
              :height="maxHeight + 'px'"
              style="width: 100%;">
      <el-table-column label="序号"
                       align="center"
                       type="index"
                       width="60"></el-table-column>
      <el-table-column label="报价ID"
                       align="center"
                       width="70"
                       prop="id"></el-table-column>
      <el-table-column label="货代拼产品名称"
                       align="center"
                       min-width="150"
                       prop="productname"></el-table-column>
      <el-table-column label="运力商产品名称"
                       align="center"
                       min-width="150"
                       prop="lineProductName"></el-table-column>
      <el-table-column label="运输方案名称"
                       align="center"
                       min-width="150"
                       prop="transportScheme"></el-table-column>
      <el-table-column label="起运地"
                       align="center"
                       width="100"
                       prop="polnamec"></el-table-column>
      <el-table-column label="目的国家"
                       align="center"
                       min-width="130"
                       prop="podnamec"></el-table-column>
      <el-table-column label="收货城市"
                       align="center"
                       width="100"
                       prop="citynamec"></el-table-column>
      <el-table-column label="报价等级"
                       align="center"
                       width="100"
                       prop="priceHeaderRank">
        <template v-slot="scope">{{ scope.row.priceHeaderRank === 1 ? '普通价' : 'VIP价' }}</template>
      </el-table-column>
      <el-table-column label="供应商名称"
                       align="center"
                       width="100"
                       prop="smartCarrier"></el-table-column>
      <el-table-column label="运输方式"
                       align="center"
                       width="100"
                       prop="transportNamec"></el-table-column>
      <el-table-column label="可走货物类型"
                       align="center"
                       width="110"
                       prop="goodstype">
        <template v-slot="scope">
          <el-tooltip placement="top">
            <div slot="content" style="max-width: 800px;">{{ scope.row.goodstype }}</div>
            <span style="text-overflow: ellipsis;-webkit-line-clamp: 3;-webkit-box-orient: vertical;display: -webkit-box;">
              {{ scope.row.goodstype }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="价格显示类型"
                       align="center"
                       width="120"
                       prop="priceDisplayType">
        <template slot-scope="scope">
          <!--{{ scope.row.priceDisplayType === 2 ? "显示" : "不显示"}}-->
          <template v-if="scope.row.priceDisplayType === 2">
            <el-button type="primary" plain  size="mini" @click="triggerDisplayType(scope.row,1)">显示</el-button>
          </template>
          <template v-else>
            <el-button type="info" plain size="mini" @click="triggerDisplayType(scope.row,2)">不显示</el-button>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="生效日期"
                       align="center"
                       width="110"
                       prop="starttime"></el-table-column>
      <el-table-column label="失效日期"
                       align="center"
                       width="110"
                       prop="endtime"></el-table-column>
      <el-table-column label="状态"
                       align="center"
                       width="60">
        <template slot-scope="scope">
          {{statusListMapObject[scope.row.state]}}
        </template>
      </el-table-column>
      <el-table-column label="录入人"
                       align="center"
                       min-width="100"
                       prop="inputer"></el-table-column>
      <el-table-column label="录入时间"
                       align="center"
                       width="150"
                       prop="inputtime"></el-table-column>
      <el-table-column label="审核人"
                       align="center"
                       min-width="100"
                       prop="reviewer"></el-table-column>
      <el-table-column label="审核时间"
                       align="center"
                       width="150"
                       prop="reviewTime"></el-table-column>
      <el-table-column label="审核原因"
                       align="center"
                       min-width="100"
                       prop="reviewReason"></el-table-column>
      <el-table-column label="操作"
                       width="160"
                       fixed="right"
                       align="center">
        <template slot-scope="scope">
          <!--<div class="table-button-plain color-primary open-hover"-->
               <!--@click="viewDetails(scope.row.id,scope.row)">查看</div>-->
          <!--<div class="table-button-plain color-primary open-hover">修改</div>-->
          <!--<div class="table-button-plain color-primary open-hover">提交</div>-->
          <el-link type=""
                   @click="viewDetails(scope.row.id,0,scope.row)">查看</el-link>
          <template v-if="scope.row.state === 1">
            <el-link type="success"
                     @click="viewDetails(scope.row.id,scope.row.state,scope.row)"
                     style="margin-left: 6px;">修改</el-link>
            <el-link type="primary"
                     @click="clickPublishOrder(scope.row)"
                     style="margin-left: 6px;">发布</el-link>
            <el-link type="danger"
                     @click="clickDeleteOrder(scope.row.id)"
                     style="margin-left: 6px;">删除</el-link>
          </template>
          <!--<template v-if="scope.row.state && scope.row.state !== 3">-->
            <!--<el-link type="danger"-->
                     <!--@click="clickCancelOrder(scope.row)"-->
                     <!--style="margin-left: 6px;">作废-->
            <!--</el-link>-->
          <!--</template>-->
          <template v-else>
            <!--已{{statusListMapObject[scope.row.state]}}-->
          </template>

          <el-link type="info" @click="clickCopyOrder(scope.row.id)" style="margin-left: 6px;" v-if="scope.row.priceHeaderRank === 1">复制</el-link>
          <el-link type="" v-if="scope.row.copyFromId"
                   @click="viewChangeList(scope.row.id,scope.row)">查看报价对比</el-link>
          <el-link type="primary" v-if="scope.row.isShowVIPCopyButton" @click="clickCopyVip(scope.row.id)">复制生成vip报价</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="paging-row"
                   style="margin-top: 10px;"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="currentPage"
                   :page-sizes="pageSizes"
                   :page-size="pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="totalListNum">
    </el-pagination>
    <edit-product-quotation-setting :visible.sync="visibleEditForm"
                                    ref="editProductQuotation"
                                    @saveSuccess="handleCurrentChange()"
                                    :type="dialogType"
    ></edit-product-quotation-setting>
    <view-product-quotation-details :visible.sync="visibleViewDetails"
                                    :data="viewFormData"
                                    :state="rowData ? rowData.state : 1"
    ></view-product-quotation-details>
    <el-dialog title="查看报价比对" :visible.sync="visibleChangeList" width="1300px">
      <el-table :data="priceChangeList" :header-cell-style="{ background: '#F3F3F3', color: '#999999' }"
                size="mini"
                v-loading="loading"
                max-height="400px"
                style="width: 100%;">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column label="关联报价ID" prop="copyFromId" align="center" width=""></el-table-column>
        <el-table-column label="当前报价ID" prop="id" align="center" width=""></el-table-column>
        <el-table-column label="专线渠道名称" prop="carrierChannelName" align="center" width=""></el-table-column>
        <el-table-column label="专线渠道代码" prop="carrierChannelCode" align="center" width=""></el-table-column>
        <el-table-column label="平台产品名称" prop="platformChannelName" align="center" width=""></el-table-column>
        <el-table-column label="平台产品代码" prop="platformChannelCode" align="center" width=""></el-table-column>
        <el-table-column label="可走货物类型" prop="goodsType" align="center" width=""></el-table-column>
        <el-table-column label="报价有效日期" prop="activeTimeRange" align="center" width=""></el-table-column>
        <el-table-column label="最新修改人" prop="updater" align="center" width=""></el-table-column>
        <el-table-column label="最新修改时间" prop="updateTime" align="center" width=""></el-table-column>
        <el-table-column label="操作" align="center" width="140">
          <template v-slot="scope">
            <!-- <el-link type=""
                     @click="viewChangeDetail(scope.row.id,scope.row)">查看变更详情</el-link> -->
                     <el-link type="info"
                     @click="viewDetails(scope.row.copyFromId,0,rowData)">查看变更前详情</el-link>
                     <el-link type="danger"
                     @click="viewDetails(scope.row.id,0,rowData)">查看变更后详情</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: auto; margin-top: 20px; text-align: center;">
        <el-button slot="footer" @click="visibleChangeList = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {mapFromArrayToObject} from "../../assets/js/utils";
  import EditProductQuotationSetting from './components-productQuotation/editProductQuotationSetting'
  import ViewProductQuotationDetails from './components-productQuotation/viewDetails/viewProductQuotationDetails'
  import {pagingMixins} from "../../assets/js/pagingMixins";
  import {getProductList} from "../../assets/js/baseDataRuquest";
  import {
    baseDataPriceDetailItem,
    createRegionHeaderPriceTable,
    disposeGetRegionHeaderList,
    disposeRequestDataToEdit, parseCityRegionHeaderPriceTable
  } from "./components-productQuotation/productQuotation";
  import {isArray, isObject} from "my-tools-kit";
  import qs from "qs";
  import {
    getRegionHeaderListDefaultChannelCode,
    initEditDataCityRegionList,
    initEditDataRegionItem
  } from "@/components/QuotationManagement/components-productQuotation/freightPrice";
  import {requestCanGetApiChannelCode} from "@/components/QuotationManagement/components-productQuotation/selectApiChannelCode/utils";
  import {sendCustomerOperationRecord} from "../../assets/js/baseDataRuquest";

  let statusArray = [
    // {label:'全部',value:'',},
    // {label:'草稿',value:1,},
    // {label:'启用',value:2,},
    // {label:'作废',value:3,},
    {label:'全部',value:'',},
    {label:'草稿',value:1,},
    {label:'待审核',value:2,},
    {label:'审核通过',value:3,},
    {label:'审核不通过',value:4,},
    {label:'作废',value:5,},
  ];
  export default {
    name: "productQuotationSetting",
    mixins:[pagingMixins],
    components:{
      EditProductQuotationSetting,
      ViewProductQuotationDetails,
    },
    data() {
      return {
        styleList:[
          {
          value: '2',
          label: '全部'
        },
          {
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }
        ],
        loading: false,
        /* 筛选 */
        searchData: {
          productId:'',
          state:'',
          isOverdue:''
        },
        /* 选择框 数据 */
        productList:[], // 物流产品
        productListMapObject:{}, // 物流产品
        // 状态
        statusList:statusArray,
        statusListMapObject:mapFromArrayToObject(statusArray),
        /* 编辑弹窗 */
        visibleEditForm: false,
        editFormData: null,
        /* 查看详情 */
        visibleViewDetails: false,
        viewFormData: {},
        deliveryTypeListMapObject: {
          KP: '卡派',
          HP: '海派',
          HK: '海卡',
          WC: '整柜直送',
          FP: '空派',
          KK: '空卡',
          KDP: '快递派',
          KH: '卡航',
          TL: '铁路'
        },
        overseasWarehouseList: [],//海外仓列表
        visibleChangeList: false,
        priceChangeList: [],
        maxHeight: 0,
        dialogType: 'add',
        rowData: {}
      }
    },
    created(){
      this.getList();
      // getProductList.call(this);
      this.getOverseasWarehouseList();
    },
    mounted(){
      this.$nextTick(() => {
        const page = document.querySelector('.page-box');
        const form = document.querySelector('#searchForm')
        const pageHeight = page.offsetHeight;
        const formHeight = form.offsetHeight
        this.maxHeight = pageHeight - formHeight - 40 - 32 - 32 - 20 - 40;
      })
    },
    methods: {
      /**
       * 获取 列表
       */
      getList() {
        let data = this.jointSearchData();
        this.loading = true;
        return this.axios.post('/carrier/productPriceNew/getCarrierProductPriceList',data,{
          // headers: {"Content-Type": "application/json",},
        })
          .then(res => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.tableData = [];
              this.totalListNum = 10;
              return this.$message.info(res.data.message || "服务器繁忙");
            }
            this.tableData = res.data.data.list;
            this.totalListNum = res.data.data.total;
            return Promise.resolve(res);
          })
          .catch((res) => {
            this.loading = false;
            this.tableData = [];
            this.totalListNum = 10;
          });
      },
      /**
       * 获取 报价详情
       */
      getQuotationDetails(id='') {
        if(!id) return false;
        this.loading = true;
        return new Promise((resolve, reject) => {
          this.axios.get('/carrier/productPriceNew/getCarrierProductPriceInfo/'+id)
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                return this.$message.info(res.data.message || "服务器繁忙");
              }
              resolve(res.data);
            })
            .catch(res => {
              this.loading = false;
            });
        })
      },
      /**
       *  其他
       */

      /*新增*/
      newDetails(id) {
        this.editFormData = {};
        this.dialogType = 'add'
        this.showEditForm();
      },
      /**
       * 查看详情
       * @param id
       * @param state {Number} 0-查看详情 1-草稿（编辑）
       * @param row
       * @returns {ElMessageComponent}
       */
      viewDetails(id='',state = 0,row) {
        if(!id) return this.$message.error('ID异常');
        this.dialogType = 'edit'
        this.getQuotationDetails(id).then(res=>{
          let data = res.data||{};
          if(state === 1){
            if(!data.id) data.id = id;
            if(isObject(row) && row.copyFromId) data.copyFromId = row.copyFromId
            this.showEditForm();
            const isVipPrice = row.priceHeaderRank === 2
            this.$refs.editProductQuotation.initEditData(data, isVipPrice);
          }else{
            this.rowData = row
            data.deliveryType = this.deliveryTypeListMapObject[data.deliveryType]||data.deliveryType;
            let overseasWarehouseItem = this.overseasWarehouseList.find(item => item.id === res.data.overseasWarehouseId);
            if(overseasWarehouseItem) data.overseasWarehouse = overseasWarehouseItem.warehouseCode;


            data.channelCode = getRegionHeaderListDefaultChannelCode(data.regionHeaderList);

            // data.regionHeaderList.forEach(item=>{
            //   if(isArray(item.cityList)) item.cityList.forEach(cityItem => {
            //     if(typeof cityItem.pickUpFlag !== "boolean") {
            //       console.log(`【${cityItem.cityName}】pickUpFlag = ${cityItem.pickUpFlag},初始化默认值`,false)
            //       cityItem.pickUpFlag = false;
            //     }
            //   })
            // })
            function regionItemCallback(item) {
              return {
                ...item,
                priceDetailList: item.priceDetailList.map(priceDetailItem=>{
                  return {
                    ...priceDetailItem,
                    volumeWeightRatio: priceDetailItem.goodsTypeList.length ?
                                        priceDetailItem.goodsTypeList[0].volumeWeightRatio : '',
                    weightVolumeRatio: priceDetailItem.goodsTypeList.length ?
                                        priceDetailItem.goodsTypeList[0].weightVolumeRatio : ''
                  }
                })
              }
            }
            let cityRegionList = initEditDataCityRegionList(data.regionHeaderList,regionItemCallback);
            cityRegionList.forEach(cityRegion=>{
              let cityList = cityRegion.cityList;
              cityList.forEach(item=>{
                let city = data.polCityList.find(city=>city.id === item.id);
                if(city) {
                  item.pickUpFlag = city.pickUpFlag;
                  item.receiveWarehouseId = city.receiveWarehouseId;
                  item.receiveWarehouseName = city.receiveWarehouseName;
                  item.platformShareWarehouseFlag = city.platformShareWarehouseFlag;
                }
              })
            })
            data.cityRegionHeaderList = cityRegionList;
            // data.deliveryCityRegionHeaderPriceTable = parseCityRegionHeaderPriceTable(cityRegionList);
            data.cityRegionHeaderPriceTable = this.disposeRegionHeaderList(data.regionHeaderList);

            if(data.isSegment){
              // let deliveryRegionHeaderList = data.deliveryRegionHeaderList.map(initEditDataRegionItem);
              // data.deliveryRegionHeaderList = deliveryRegionHeaderList;
              // data.cityRegionHeaderPriceTable = createRegionHeaderPriceTable(deliveryRegionHeaderList);
              data.deliveryCityRegionHeaderPriceTable = this.disposeRegionHeaderList(data.deliveryRegionHeaderList);
            }
            data.endDeliveryTypeNames = data.endDeliveryTypeNames && data.endDeliveryTypeNames.length ? data.endDeliveryTypeNames.join(',') : '';

            this.viewFormData = data;
            this.visibleViewDetails = true;
          }
        })
      },
      disposeRegionHeaderList(regionList = []){
        let newList = [];
        regionList.forEach((regionItem,regionIndex)=>{
          let cityList = regionItem.cityList||[];
          let regionDetailList = regionItem.regionDetailList||[];
          regionItem.priceDetailList.forEach((item,index)=>{
            let data = Object.assign(item,{
              cityList,
              regionDetailList,
              regionName:regionItem.regionName,

              // "extractionAgingFrom": regionItem.extractionAgingFrom, //提取时效最短时间
              // "extractionAgingTo": regionItem.extractionAgingTo, // 提取时效最长时间
              // "extractionAgingUnit": regionItem.extractionAgingUnit, // 提取时效单位 1：工作日 2：自然日
              // "agingFrom": regionItem.agingFrom, // 整体时效最短时间
              // "agingTo": regionItem.agingTo, // 整体时效最长时间
              // "agingUnit": regionItem.agingUnit, // 整体时效单位 1：工作日 2：自然日
              //拆柜城市id
              "dismantlingCityId":regionItem.dismantlingCityId||"",
              //拆柜城市名称
              "dismantlingCityName":regionItem.dismantlingCityName||"",
              volumeWeightRatio: item.goodsTypeList && item.goodsTypeList.length ?
                                 item.goodsTypeList[0].volumeWeightRatio : '',
              weightVolumeRatio: item.goodsTypeList && item.goodsTypeList.length ?
                                 item.goodsTypeList[0].weightVolumeRatio : '',
            })
            newList.push(data);
          })
        });
        return newList;
      },
      /* 复制 */
      clickCopyOrder(id) {
        if(!id) return this.$message.error('ID异常');
        this.dialogType = 'add'
        this.getQuotationDetails(id).then(res=>{
          let data = res.data||{};
          data.effectiveStartTime = '';
          data.effectiveEndTime = '';
          data.copyFromId = data.id
          data.id = '';
          this.showEditForm();
          this.$refs.editProductQuotation.initEditData(data);
        })
      },
      /* 删除 */
      clickDeleteOrder(id) {
        if (!id) return this.$message.error('ID异常');
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteOrder(id);
        })
      },
      deleteOrder(id) {
        this.axios.delete('/carrier/productPriceNew/deleteCarrierProductPriceById/' + id)
          .then(res=>{
            res = isObject(res.data) ? res.data : {};
            if(res.code !== 200) return Promise.reject(new Error(res.message));
            return res;
          })
          .then(res => {
            this.loading = false;
            this.$message.success("删除成功");
            this.getList();
          })
          .catch(res => {
            this.loading = false;
            this.$message.info(res.data.message || "服务器繁忙");
          });
      },
      /**
       * 修改 产品报价 状态
       */
      editOrderStatus(row={},status=0) {
        if(!status) return this.$message.error('status不能为空');
        let data = {
          id:row.id,
          status,
        };
        this.loading = true;
        // this.axios.post('/erp/service?src=jiuyuPrice&action=updateJiuyuProductPriceStatus', data, {
        //   headers: {"Content-Type": "application/json",}
        // })
        this.axios.post('/carrier/productPriceNew/submitCarrierProductPrice', data)
          .then(res => {
            res = isObject(res.data) ? res.data : {};
            if(res.code !== 200) return Promise.reject(new Error(res.message));
            return res;
          })
          .then(res => {
            this.loading = false;
            if(status === 2){
              this.$message.success("发布成功");
            }else if(status === 2){
              this.$message.warning("已作废");
            }
            this.getList();
          })
          .catch(res => {
            this.loading = false;
            this.$message.error(`${res.message||"网络异常，请稍后再试"}`);
          })
      },
      /* 发布 */
      clickPublishOrder(row={}){
        this.$confirm('此操作将使该报价提交审核,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
          this.editOrderStatus(row,2);
          const buttonName = row.copyFromId? '复制报价提交' : '发布报价提交';
          const operationText = `${row.copyFromId? '关联报价ID：' + row.copyFromId + '，' : ''}专线产品名称：${row.lineProductName}，运输方案：${row.transportScheme||'-'}，起运地：${row.citynamec}，目的国：${row.podnamec}，运输方式：${row.transportNamec}`
          sendCustomerOperationRecord(buttonName, operationText)
        }).catch(() => {

        });
      },
      /* 作废 */
      clickCancelOrder(row={}){
        this.$confirm('此操作将作废该报价设置, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.editOrderStatus(row,3);
        }).catch(() => {

        });
      },
      getOverseasWarehouseList(countryId="") {
        let url = `/api/carrier/base/findCarrierOverseasWarehouseList`;
        let data = {
          countryId,
        };
        this.axios.post(url,qs.stringify(data))
          .then(res=>{
            res = isObject(res.data) ? res.data : {};
            if(res.code !== 200) return Promise.reject(new Error(res.message));
            return res;
          })
          .then(res => {
            this.overseasWarehouseList = res.datas || [];
          })
          .catch(res=>{
            this.overseasWarehouseList = [];
          })
      },
      /**
       * 切换价格显示类型
       * @param item
       * @param type
       */
      triggerDisplayType(item,type){
        let url = "/api/carrier/productPriceNew/updateProductPriceDisplayType";
        let data = {
          "id": item.id||"",//报价id
          "priceDisplayType": type||1,//价格显示类型，1：不显示 2：显示
        };
        this.loading = true;
        return this.axios.post(url,data)
          .then(res=>{
            res = isObject(res.data) ? res.data : {};
            if(res.code !== 200) return Promise.reject(new Error(res.message));
            return res;
          })
          .then(res=>{
            this.loading = false;
            this.$message.success("设置成功");
            this.getList();
          })
          .catch(res=>{
            this.loading = false;
            this.$message.error(`切换价格显示类型：${res.message||"网络异常，请稍后再试"}`);
          })
      },
      /*查看报价变动记录列表*/
      viewChangeList(id, row) {
        this.rowData = row
        this.visibleChangeList = true
        this.axios.get(`/api/carrier/productPriceNew/viewQuoteComparisonById/${id}`).then(res => {
          if (res.data.code === 200) {
            res.data.data.activeTimeRange = `${res.data.data.beginTime} 至 ${res.data.data.endTime}`
            this.priceChangeList = [res.data.data]}
        })
      },
      /* 查看报价变动详情 */
      viewChangeDetail(id, row) {

      },
      getQuotationChangeDetails() {
        return new Promise((resolve, reject) => {
          this.axios.post(`/api/FBAfee/queryQuotedPriceDetailInfoWithoutLogin?productPriceHeaderId=${id}`)
        })
      },
      clickCopyVip(id) {
        if(!id) return this.$message.error('ID异常');
        this.dialogType = 'add'
        this.getQuotationDetails(id).then(res=>{
          let data = res.data||{};
          data.copyFromId = data.id
          data.id = '';
          this.showEditForm();
          this.$refs.editProductQuotation.initEditData(data, true);
        })
      }
    },
  }
</script>

<style >

</style>
<style scoped>
  a:hover{
    text-decoration: none;
  }
  /deep/ .el-form-item--mini.el-form-item {
    margin-bottom: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/productQuotationSetting.vue